module.exports = __webpack_public_path__ + "static/media/annotate_pencil_light.9330cd83.svg";